import { render } from "./CaretRight.vue?vue&type=template&id=33f05b67"
import script from "./CaretRight.vue?vue&type=script&setup=true&lang=js"
export * from "./CaretRight.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/CaretRight.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33f05b67"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33f05b67', __exports__)) {
    api.reload('33f05b67', __exports__)
  }
  
  module.hot.accept("./CaretRight.vue?vue&type=template&id=33f05b67", () => {
    api.rerender('33f05b67', render)
  })

}


export default __exports__